/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Upload_Unsupported_TypeInputs */

const en_doc_upload_unsupported_type = /** @type {(inputs: Doc_Upload_Unsupported_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File type is not supported`)
};

const pt_br2_doc_upload_unsupported_type = /** @type {(inputs: Doc_Upload_Unsupported_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de arquivo não suportado`)
};

/**
* | output |
* | --- |
* | "File type is not supported" |
*
* @param {Doc_Upload_Unsupported_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_upload_unsupported_type = /** @type {((inputs?: Doc_Upload_Unsupported_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Upload_Unsupported_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_upload_unsupported_type(inputs)
	return pt_br2_doc_upload_unsupported_type(inputs)
});